import { render } from "./LeadForm.vue?vue&type=template&id=4b8fa7fe&scoped=true"
import script from "./LeadForm.vue?vue&type=script&lang=js"
export * from "./LeadForm.vue?vue&type=script&lang=js"

import "./LeadForm.vue?vue&type=style&index=0&id=4b8fa7fe&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8fa7fe"]])

export default __exports__